import svg from './_svg'

export default {
  'Template Listing': {
    title: 'ADD_TEMPLATE',
    url: '/templates/new',
    icon: svg.add,
    type: 'url'
  },
  'Reports': {
    title: 'EXPORT',
    url: '',
    icon: svg.export,
    type: 'button'
  },
  'Users': {
    title: 'ADD_NEW_USER',
    url: '/admin/new',
    icon: svg.add,
    type: 'url'
  },
  'Log History': {
    title: 'EXPORT',
    url: '',
    icon: svg.export,
    type: 'button'
  },
  'Train': {
    title: 'UPLOAD_FORM',
    url: '/process/upload',
    icon: svg.upload,
    type: 'url'
  },
  'Accounts': {
    title: 'NEW_ACCOUNT',
    url: '/super_admin/new',
    icon: svg.add,
    type: 'url'
  }
}



// WEBPACK FOOTER //
// ./src/_fab.js